import { NewCard } from "@components/Cards/Templates/newCard";
import { UserFieldErrorMessages } from "@constants/Errors";
import {
  handleHiraganaKanaChange,
  handleNumericalCheck,
} from "@services/ErrorHandling";

type AdminUserInfoCardProps = {
  loading: boolean;
  adminUserData: any;
  updateAdminData: (field: string, value: any) => void;
  updateError: (field: string, value: any) => void;
  errors: any;
  setPasswordModalOpen: (isOpen: boolean) => void;
};

export const AdminUserInfoCard = ({
  loading,
  adminUserData,
  updateAdminData,
  updateError,
  errors,
  setPasswordModalOpen,
}: AdminUserInfoCardProps) => {
  return (
    <>
      <NewCard
        header={"管理者情報"}
        bodyLabel={""}
        loading={loading}
        bodyContents={
          <div>
            <div>
              <h2 className="mb-5 label-light-blue-xl">
                {" "}
                氏名 <span className="text-red-500">*</span>{" "}
              </h2>
              <div className="flex">
                <div>
                  <h2 className="mb-5 label-light-blue-md"> 姓 </h2>
                  <input
                    type="text"
                    className="form-text-field-border"
                    value={adminUserData?.last_name}
                    placeholder="山田"
                    required
                    onChange={(e) =>
                      handleNumericalCheck(
                        "last_name",
                        e.target.value,
                        updateAdminData,
                        updateError,
                      )
                    }
                  />
                  {errors.last_name && (
                    <p className="text-red-500">
                      {UserFieldErrorMessages.nameError}
                    </p>
                  )}
                </div>

                <div>
                  <h2 className="mb-5 label-light-blue-md"> 名 </h2>
                  <input
                    type="text"
                    placeholder="太郎"
                    className="form-text-field-border"
                    value={adminUserData?.first_name}
                    required
                    onChange={(e) =>
                      handleNumericalCheck(
                        "first_name",
                        e.target.value,
                        updateAdminData,
                        updateError,
                      )
                    }
                  />
                  {errors.first_name && (
                    <p className="text-red-500">
                      {UserFieldErrorMessages.nameError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-5 divider"></div>

            <div>
              <h2 className="mb-5 label-light-blue-xl"> 氏名ふりがな </h2>
              <div className="flex">
                <div>
                  <h2 className="mb-5 label-light-blue-md"> 姓 </h2>
                  <input
                    type="text"
                    placeholder="やまだ"
                    className="form-text-field-border"
                    value={adminUserData?.last_furigana_name}
                    onChange={(e) =>
                      handleHiraganaKanaChange(
                        "last_furigana_name",
                        e.target.value,
                        updateAdminData,
                        updateError,
                      )
                    }
                  />
                  {errors.last_furigana_name && (
                    <p className="text-red-500">
                      {UserFieldErrorMessages.nameHiraganaError}
                    </p>
                  )}
                </div>

                <div>
                  <h2 className="mb-5 label-light-blue-md"> 名 </h2>
                  <input
                    type="text"
                    placeholder="たろう"
                    className="form-text-field-border"
                    value={adminUserData?.first_furigana_name}
                    onChange={(e) =>
                      handleHiraganaKanaChange(
                        "first_furigana_name",
                        e.target.value,
                        updateAdminData,
                        updateError,
                      )
                    }
                  />
                  {errors.first_furigana_name && (
                    <p className="text-red-500">
                      {UserFieldErrorMessages.nameHiraganaError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-5 divider"></div>

            <h2 className="mb-6 label-light-blue-xl">
              メールアドレス <span className="text-red-500">*</span>
            </h2>
            <div className="flex justify-between items-center">
              <input
                type="email"
                placeholder="yamada.taro@email.com"
                required
                className="form-text-field-border"
                value={adminUserData?.login_id}
                onChange={(e) => updateAdminData("login_id", e.target.value)}
              />
              {adminUserData?.login_password && (
                <div className="flex items-center ml-4 mr-2 text-xl">
                  <span className="mr-2">{`最初のパスワード:`}</span>
                  <span className="font-bold">
                    {adminUserData?.login_password}
                  </span>
                </div>
              )}
              <button
                className="button-default-white justify-end items-center max-w-50 min-w-50 hover:opacity-50"
                type="button"
                onClick={() => setPasswordModalOpen(true)}
              >
                パスワード初期化
              </button>
            </div>
            <div className="mt-5 divider"></div>
          </div>
        }
      ></NewCard>
    </>
  );
};
